import { render } from "./ClaimSection.vue?vue&type=template&id=f0d14a86&scoped=true"
import script from "./ClaimSection.vue?vue&type=script&lang=js"
export * from "./ClaimSection.vue?vue&type=script&lang=js"

import "./ClaimSection.vue?vue&type=style&index=0&id=f0d14a86&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d14a86"]])

export default __exports__